@if ((devices$ | async)?.length > 0) {
<div class="row g-0 my-1">
  @for (appleDevice of appleDevices$ | async; track appleDevice) {
  <div class="col-12 col-md-6">
    <div class="bg-white border m-1 pt-3 px-3 d-flex flex-column shadow-sm">
      <era-apple-device [udid]="appleDevice.deviceId"></era-apple-device>
      <era-device-action-bar-ui [device]="appleDevice"></era-device-action-bar-ui>
    </div>
  </div>
  }
</div>
} @else {
<p class="pt-2 px-3">There are no devices assigned to this room.</p>
}